import { newEditTransmitterDialog } from '../reducers/edit_transmitter_dialog';
import { showDialog } from '../reducers/app';
export function newTransmitter() {
    return (dispatch) => {
        dispatch(newEditTransmitterDialog());
        dispatch(showDialog('transmitter-edit'));
    };
}
